export const initialState = {
  loading: false,
  selectedTab: 0,
  contractHistoryData: [],
  isCountryHistoryResults :false,
  contractHistoryTotalCount: 0,
  contractHistoryView:'',
  contractReturnTocreate:'',
  returnToCreateModal:false,
  isModifyModal:false,
  contractHistoryViewForm:{
    comment:'',
  },
  contractViewBackup:null,
  isHistoryViewBackUp : false,
  
  //create submit modal
  isCreateSubmitModal:false,
  createSubmitViewForm:{
    comment:'',
  },
  savingCreate:false,
  savingCreateData:"",
  isRecordSubmitted:false,
  isFailed:false,
  contractHistoryCPIData: [],
  contractHistoryCPITotalCount: 0,
  isCountryHistoryCPIResults: false,
};
